// loadJs('https://res.wx.qq.com/open/js/jweixin-1.2.0.js', requestHmlWx);
function requestHmlWx(wxshareData){
    let xmlhttp;
    if(window.XMLHttpRequest){
        // IE7+, Firefox, Chrome, Opera, Safari 浏览器执行的代码
        xmlhttp=new XMLHttpRequest();
    }
    else{    
        //IE6, IE5 浏览器执行的代码
        xmlhttp= new ActiveXObject("Microsoft.XMLHTTP");
    }
    xmlhttp.onreadystatechange=function(){
        if (xmlhttp.readyState==4 && xmlhttp.status==200){
            var ret = JSON.parse(xmlhttp.responseText);
             // console.log(wx.ready);
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。      
                appId: ret.appId,
                timestamp: ret.timestamp,
                nonceStr: ret.nonceStr,
                signature: ret.signature,
                url: ret.url,
                jsapiTicket: ret.jsapiTicket,
                rawString: ret.rawString,
                jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            wx.ready(function () {
                var shareData = wxshareData;
                // console.log(shareData);
                wx.onMenuShareAppMessage(shareData);
                wx.onMenuShareTimeline(shareData);
                // alert("微信加载完毕");
            });
        }
    }
    xmlhttp.open("GET","https://vrbuy.hmltec.com/api/wxsdk.php");
    xmlhttp.send();
}


function initBaiduTongji(id){
    var _hmt = _hmt || [];
    (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?" + id;
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
    })();
}
export {
    requestHmlWx,
    initBaiduTongji
}